import { TriggeredMessageViewFragment } from '@occc/graphql';
import { ErrorCard, LoadingCard } from '@occc/ui-design-system';

import { TriggeredMessageData } from './triggered-message-data';

type TriggeredMessageStateProps = {
  message?: TriggeredMessageViewFragment | null;
  loading: boolean;
};

export const TriggeredMessageState = (props: TriggeredMessageStateProps) => {
  const { message, loading } = props;

  if (loading && !message) {
    return <LoadingCard />;
  }

  if (!message) {
    return <ErrorCard />;
  }

  return <TriggeredMessageData message={message} />;
};
